import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { usePermissions } from '@/hooks/usePermissions';
import type { Role, Scope, Resource } from '@/types/rbac';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Role mínima exigida para acessar a rota */
  requiredRole?: Role;
  /** Resource para verificação de scope */
  resource?: Resource;
  /** Scope exigido para o resource */
  scope?: Scope;
}

export function ProtectedRoute({
  children,
  requiredRole,
  resource,
  scope,
}: ProtectedRouteProps) {
  const { isAuthenticated, isInitialized } = useAuthStore();
  const { hasRole, hasScope } = usePermissions();
  const location = useLocation();

  // Aguardar a inicialização antes de verificar autenticação
  if (!isInitialized) {
    return null;
  }

  // Verificar autenticação (comportamento existente preservado)
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar role RBAC
  if (requiredRole && !hasRole(requiredRole)) {
    return <Navigate to="/access-denied" replace />;
  }

  // Verificar scope RBAC
  if (resource && scope && !hasScope(resource, scope)) {
    return <Navigate to="/access-denied" replace />;
  }

  return <>{children}</>;
}
